import React          from 'react';
import PageSelector   from '../PageSelector';
import LangSelector   from '../LangSelector';
import SignOutButton  from '../SignOutButton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        position:        'fixed',
        left:            0,
        top:             100,
        width:           '100vw',
        height:          '100vh',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
        transition:      'all 0.5s',
        overflow:        'hidden',
        backgroundColor: '#FFF'
    }
}))

type navbarProps = {
  size:               number[];
  pages:              string[];
  page:               string;
  lang:               string;
  showSmallNavBar:    boolean;
  setLang:            (val: string) => void;
  handleNavBarClick:  (val: string) => void;
  setShowSmallNavBar: (val: boolean) => void;
  logOut:             () => void;
}

const Navbar: React.FC<navbarProps> = ({ 
  size,
  pages,
  page, 
  lang,
  showSmallNavBar,
  setLang,
  handleNavBarClick,
  setShowSmallNavBar,
  logOut
}) => {

  const classes = useStyles();

   const navStyle = React.useMemo(() => {
      return {
        height:  showSmallNavBar ? size[1] - 100 : 0,
        top:     showSmallNavBar ? 100 : 0,
      }
  },[size, showSmallNavBar]) 


  return (
    <div 
       className = { classes.root }
       style     = { navStyle }
       onClick   = { () => { setShowSmallNavBar(false) }}
    >
        <LangSelector
           variant = { lang === 'heb' ? 'arab' : 'heb' }
           lang    = { lang }
           setLang = { setLang }
        />
        {
           pages.map((val) => {
              return(
                <PageSelector
                   key             = { `${ val }_` }
                   val             = { val }
                   ind             = { -1 }
                   size            = { size }
                   page            = { page }
                   lang            = { lang }
                   showSmallNavBar = { showSmallNavBar }
                   handleClick     = { handleNavBarClick }
                />
              )
           })
        }
        <SignOutButton
           lang   = { lang }
           logOut = { logOut }
        />
    </div>
  );
}




export default Navbar;

